import { FC, ReactNode } from 'react'
import {
  MembershipSubscriptionAvatar,
  MembershipSubscriptionAvatarType,
} from './Avatar'
import {
  SubscriptionDescription,
  SubscriptionDescriptionType,
} from './Description'
import {
  SubscriptionFormAnswers,
  SubscriptionFormAnswersType,
} from './FormAnswers'
import {
  SubscriptionPaymentData,
  SubscriptionPaymentDataType,
} from './PaymentData'
import {
  MembershipSubscriptionReviewModal,
  MembershipSubscriptionReviewModalType,
} from './ReviewModal'
import { TagManager, TagManagerType } from './TagManager'

const MembershipSubscription: FC &
  MembershipSubscriptionAvatarType &
  MembershipSubscriptionReviewModalType &
  TagManagerType &
  SubscriptionDescriptionType &
  SubscriptionPaymentDataType &
  SubscriptionFormAnswersType = (): ReactNode => <></>

MembershipSubscription.Avatar = MembershipSubscriptionAvatar
MembershipSubscription.ReviewModal = MembershipSubscriptionReviewModal
MembershipSubscription.Description = SubscriptionDescription
MembershipSubscription.TagManager = TagManager
MembershipSubscription.PaymentData = SubscriptionPaymentData
MembershipSubscription.FormAnswers = SubscriptionFormAnswers

export default MembershipSubscription
